const styles = (theme) => ({
    stepperRoot: {
    //        height: '90%',
            boxShadow: '2px 2px 5px rgba(200,200,200,0.6)'
    },
    stepper: {
        maxHeight: '100%',
        borderRadius: '5px'
    },
    stepRoot: {
        // height: '450px'
    },
    button: {
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    downloadButton: {
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        '&:disabled': {
            backgroundColor: 'rgba(240, 240, 240, 1)',
        }
    },
    // disabled: {
    //     border: '2px solid blue',
    //     color: 'white'
    // },
    actionsContainer: {
        marginBottom: theme.spacing.unit * 2,
        display: 'flex'
    },
    resetContainer: {
        padding: theme.spacing.unit * 3,
    },
    connectorActive: {
        '& $connectorLine': {
            // borderColor: theme.palette.secondary.main,
            borderWidth: '3px'
        },
    },
    connectorCompleted: {
        '& $connectorLine': {
            borderColor: theme.palette.primary.main,
        },
    },
    connectorDisabled: {
        '& $connectorLine': {
            borderColor: theme.palette.grey[100],
            
        },
    },
    connectorLine: {
        borderWidth: '3px',
        transition: theme.transitions.create('border-color'),
    },
    uploadSuccess: {
        backgroundColor: 'rgba(67,160,71,1)',
        margin: theme.spacing.unit
    },
    warningSnackbar: {
        backgroundColor: 'rgb(255,197,58,1)',
        color: 'black',
        margin: theme.spacing.unit
    },

    modelNextWrapper: {
        // margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: 'rgba(76,175,80,1)',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -16,
    },
    lightBox: {
        // zIndex: '2000'
    }
});
    
export default styles;
